import type { FC } from 'react';
import GeneralSkeleton from '@/components/skeletons/GeneralSkeleton';
import { AppParameter, setAppCookie } from '@/helpers/conf';
import { useCookie } from '@/hooks/common';
import { useCMSCasinoBonuses } from '@/modules/bonuses';
import { Card } from './components/Card';
import {
  HavePromocodeSection,
  type IHavePromocodeSectionProps,
} from './components/HavePromocodeSection';
import { NotFoundPromotions } from './components/NotFoundPromotions';

import { ScAllOffers, ScCardRow } from './styled';

export const AllOffers: FC<IHavePromocodeSectionProps> = (props) => {
  const { bonuses: selectedBonuses, isLoading } = useCMSCasinoBonuses();

  useCookie(setAppCookie({ name: AppParameter.PromoPage }));

  return (
    <ScAllOffers>
      {isLoading ? (
        <GeneralSkeleton />
      ) : selectedBonuses.length ? (
        <ScCardRow>
          {selectedBonuses.map((bonus) => (
            <Card key={bonus.id} {...bonus} />
          ))}
        </ScCardRow>
      ) : (
        <NotFoundPromotions />
      )}
      <HavePromocodeSection isLoading={isLoading} {...props} />
    </ScAllOffers>
  );
};
